module.exports = __webpack_public_path__ + "static/img/FuQuan_jianjiePic.0501be37.png";